//This is a generic message service that can be used to communicate between any 2 components
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Recordable } from '../types/recordable';

@Injectable({
    providedIn: "root"
})
export class MessageService {
    private subject = new Subject<any>();
    private recordableSub = new Subject<Recordable>();

    sendMessage(message: any) {
        this.subject.next(message);
    }

    sendEmailRecordable(recordable: Recordable) {
        this.recordableSub.next(recordable);
    }

    clearMessages() {
        this.subject.next(undefined);
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    getEmailRecordable(): Observable<Recordable> {
        return this.recordableSub.asObservable();
    }
}